// extracted by mini-css-extract-plugin
module.exports = {"catLink":"index-module--catLink--2JnR6","icon":"index-module--icon--1hQAp","title":"index-module--title--1dUxk"};